interface Props {
  page: number;
  pageCount: number;
  onChange: (page: number) => void;
}

/**
 * Previous / next across the results.
 *
 * <p>Two buttons and a position rather than numbered pages: numbers are worth their complexity
 * when someone might jump to page 7, which assumes they know what's on it. Here the list is
 * ordered by whatever they chose — soonest, nearest, cheapest — so the useful moves are "more of
 * the same" and "back", and page 7 means nothing to anyone.
 */
export function Pagination({ page, pageCount, onChange }: Props) {
  if (pageCount <= 1) return null;

  return (
    <nav className="pagination" aria-label="Results pages">
      <button
        type="button"
        className="button"
        disabled={page === 1}
        onClick={() => onChange(page - 1)}
      >
        Previous
      </button>

      {/* Announced, because for a screen reader the only evidence the button did anything is the
          table quietly swapping its contents. */}
      <p className="pagination__status" aria-live="polite">
        Page {page} of {pageCount}
      </p>

      <button
        type="button"
        className="button"
        disabled={page === pageCount}
        onClick={() => onChange(page + 1)}
      >
        Next
      </button>
    </nav>
  );
}
